import { EngineInvariantError } from "../errors";
import type { Coord, GameState, Tile, Unit } from "./types";

function tileIndex(dims: { width: number }, coord: Coord): number {
  return coord.y * dims.width + coord.x;
}

export function getTile(state: GameState, coord: Coord): Tile {
  const tile = state.tiles[tileIndex(state, coord)];
  if (!tile) {
    throw new EngineInvariantError(`No tile at (${coord.x}, ${coord.y})`);
  }
  return tile;
}

export function inBounds(dims: { width: number; height: number }, coord: Coord): boolean {
  return coord.x >= 0 && coord.x < dims.width && coord.y >= 0 && coord.y < dims.height;
}

export function manhattan(a: Coord, b: Coord): number {
  return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
}

export function coordEq(a: Coord, b: Coord): boolean {
  return a.x === b.x && a.y === b.y;
}

export function coordKey(c: Coord): string {
  return `${c.x},${c.y}`;
}

export function coordFromKey(key: string): Coord {
  const [x, y] = key.split(",").map(Number);
  return { x: x as number, y: y as number };
}

export function neighbors(coord: Coord): Coord[] {
  return [
    { x: coord.x + 1, y: coord.y },
    { x: coord.x - 1, y: coord.y },
    { x: coord.x, y: coord.y + 1 },
    { x: coord.x, y: coord.y - 1 },
  ];
}

export function unitAt(state: GameState, coord: Coord): Unit | undefined {
  return state.units.find((u) => u.pos.x === coord.x && u.pos.y === coord.y);
}

export function findUnit(state: GameState, id: string): Unit {
  const u = state.units.find((u) => u.id === id);
  if (!u) {
    throw new EngineInvariantError(`Unknown unit ${id}`);
  }
  return u;
}
